import { createSelector } from '@reduxjs/toolkit';
import { selectLandArea, selectTotalArea } from 'shared/selectors/jsonQuery';
import { getTitle } from './utils';

export const selectSuburbanAreaLabel = createSelector([selectTotalArea, selectLandArea], (totalArea, landArea) => {
  const { gte: houseAreaMin = null, lte: houseAreaMax = null } = totalArea || {};
  const { gte: landAreaMin = null, lte: landAreaMax = null } = landArea || {};

  return (
    [getTitle(houseAreaMin, houseAreaMax, 'м²'), getTitle(landAreaMin, landAreaMax, 'сот.')]
      .filter(Boolean)
      .join('・') || 'Площадь'
  );
});
